import React, { useCallback, useEffect, useState } from "react";
import { Topbar } from "@components";
import { Avatar, message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import moment from "moment";
import { LIMITS } from "@constants";
import {
	RootContainer,
	SpinWrapper,
	OuterDiv,
	IndexNumber,
	FriendInfo,
	InfoText,
	TitleWrapper,
	Number,
	FriendListWrapper,
	DateText,
	TitleDiv,
	Title,
	SubTitle,
	NoFriendListWrapper,
	NoFriendText,
	TopImage,
} from "./FriendList.style";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import { NoFriendList, NoImageUser } from "@assets";

const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const FriendList = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [page, setPage] = useState(DEFAULT_PAGE);
	const [dataLength, setDataLength] = useState(0);

	const getFriendList = useCallback(() => {
		api
			.getFriends({
				page,
				limit: PAGE_SIZE,
			})
			.then(({ users, pagination }) => {
				setDataLength(pagination.total);
				if (page === 1) {
					setData([...users]);
				} else {
					setData((prev) => [...prev, ...users]);
				}
				setLoading(false);
			})
			.catch((errorMsg) => {
				setLoading(false);
				message.error(errorMsg);
			});
	}, [page]);

	useEffect(() => {
		getFriendList();
	}, [getFriendList]);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
	};

	const renderTop = () => (
		<TitleDiv>
			<TitleWrapper>
				<Title>{t("profile.friendListHeading1")}</Title>
				<SubTitle> {data.length} </SubTitle>
			</TitleWrapper>
		</TitleDiv>
	);

	const FriendCard = ({ friend, index }) => {
		return (
			<OuterDiv>
				<Number>{index + 1 + "."}</Number>
				<Avatar size={40} src={NoImageUser} />
				<IndexNumber>
					<FriendInfo>
						<InfoText isName={true}>{friend.name}</InfoText>
						<InfoText>{`*******${friend.phone.substr(-4)}`}</InfoText>
					</FriendInfo>
				</IndexNumber>
				<DateText>
					{moment.unix(friend.created_at).format("MMM DD, YYYY")}
				</DateText>
			</OuterDiv>
		);
	};

	return (
		<>
			<Topbar
				title={t("profile.friendListTitle")}
				goBack={goBack}
				shadow={false}
			/>
			<RootContainer>
				{!loading && data.length < 1 ? (
					<NoFriendListWrapper>
						<NoFriendList />
						<NoFriendText>{t("profile.noInviteFriend")}</NoFriendText>
					</NoFriendListWrapper>
				) : (
					<>
						{(!loading || page > 1) && <TopImage />}
						{(!loading || page > 1) && renderTop()}
						<FriendListWrapper id="scrollableDiv">
							<InfiniteScroll
								style={{
									maxHeight: "600px",
								}}
								dataLength={data.length}
								next={() => {
									setPage((prev) => prev + 1);
								}}
								hasMore={loading || data.length !== dataLength}
								loader={
									<SpinWrapper page={page}>
										<Spin size="small" />
									</SpinWrapper>
								}
								scrollableTarget="scrollableDiv"
							>
								{data.map((friend, index) => (
									<FriendCard friend={friend} index={index} />
								))}
							</InfiniteScroll>
						</FriendListWrapper>
					</>

				)}
			</RootContainer>
		</>
	);
};

export default FriendList;
